var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListOrdered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.3 38.9h5.9v1.4h-3v3h3v1.4H.3v3h8.9V35.8H.3v3.1zm3-26.8h3V.2h-6v3h3v8.9zM.3 21h5.3L.3 27.2v2.6h8.9v-3H3.9l5.3-6.2V18H.3v3zM15.2 3.2v5.9h32.6V3.2H15.2zm0 41.6h32.6v-5.9H15.2v5.9zm0-17.8h32.6v-6H15.2v6z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNLjMgMzguOWg1Ljl2MS40aC0zdjNoM3YxLjRILjN2M2g4LjlWMzUuOEguM3YzLjF6bTMtMjYuOGgzVi4yaC02djNoM3Y4Ljl6TS4zIDIxaDUuM0wuMyAyNy4ydjIuNmg4Ljl2LTNIMy45bDUuMy02LjJWMThILjN2M3pNMTUuMiAzLjJ2NS45aDMyLjZWMy4ySDE1LjJ6bTAgNDEuNmgzMi42di01LjlIMTUuMnY1Ljl6bTAtMTcuOGgzMi42di02SDE1LjJ2NnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgListOrdered as ReactComponent };